import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SearchInsuranceModel, AddInsuranceModel, SerchInsuranceResponceModel, UpdateInsuranceModel, UpdateSubscriberInfo, PatienT_INSURANCE_INFO, AddSubscriberResponse, getSubscriberDetails, OcrResponce, DeleteInsuranceModel, OcrResponceNew } from 'src/app/models/insurance/inurance';
import { InsuranceService } from 'src/app/services/insurance.service';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UpdateinfoService } from 'src/app/services/updateinfo.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SmartyAddressService } from '../../services/smarty-address.service';
import { IntakeMedicationService } from '../../services/intake-Medication.service';
import { VerifypatientService } from '../../services/verifypatient.service';
import { UpdatePatientSelfPayBitRequest } from 'src/app/models/insurance/inurance';
import { InsurancePhase2Service } from '../../services/insuranceservicephase2/insurance-phase2.service';
var objectCopyInsurance: any;
declare var $: any;

@Component({
  selector: 'app-inusrances',
  templateUrl: './inusrances.component.html',
  styleUrls: ['./inusrances.component.css']
})
export class InusrancesComponent implements OnInit {
  subSAction: any = "Add";
  pageNum: any;
  totalPages: any;
  searchinsurancemodel: SearchInsuranceModel;
  insurancemodel: boolean = false;
  //CityandStateRequest: CityandStateRequest;
  _addpatientinsurancemodel: AddInsuranceModel;
  getSubscriberDetails: getSubscriberDetails;
  _guarantor: AddSubscriberResponse;
  searchinsuranceresponce: SerchInsuranceResponceModel;
  UpdateInsuranceModel: UpdateInsuranceModel;
  patientpersonalinfo: any;
  _updatesubscriberinfo: UpdateSubscriberInfo;
  _firstNameReq: boolean = false;
  _lastNameReq: boolean = false;
  addressReq: boolean = false;
  zipReq: boolean = false;
  zipLengthReq: boolean = false;
  subcriberReq: boolean = false;
  saveButtonCheck: boolean = false;
  _cityandstateList: any;
  isZipCodeNotValidSuubscriberInfo: boolean = false;
  _insurances: PatienT_INSURANCE_INFO[] = [];
  filterInsuranceSearch: any
  isInsuranceData: boolean = true;
  searchInsuranceFC = new FormControl();
  isLoading: boolean = false;
  insuranceNameError: boolean = false;
  isShowSubscriberForm: boolean = false;
  insurancecat: string = "P";
  displayInsuranceName: string = '';
  maxDate: any;
  insurancetype: any = "Add";
  OcrResponce = new OcrResponce();
  OcrResponceNew = new OcrResponceNew();
  isPopup: boolean = false;
  defaultImagefront: any;
  defaultImageback: any;
  //for insurances filter 
  selectedState: any = 'state';
  Insurancefilter: any = ['all', 'state', 'list']
  InsuranceDetails: boolean;
  addInsurance: boolean;
  noInsuranceScreen: boolean;
  addressOptions: any = [];
  fileArray = Array();
  fileObjFront: any;
  fileObjBack: any;
  isFrontPhotoUpload: boolean = false;
  isbackPhotoUpload: boolean = false;
  practiceState: any = '';
  practiceCity: any = '';
  pcpStatus: any = '';
  insuranceStatus: any = '';
  notificationCount: any = 0;
  showNotificationIcon: boolean = false;
  isPrimaryInsuranceInactive: boolean = false;
  isPrimaryInsurancealredyExist: boolean = false;
  appointmentId: any;
  UpdatePatientSelfPayBitRequest: UpdatePatientSelfPayBitRequest = new UpdatePatientSelfPayBitRequest();
  providerFname: any = '';
  providerLname: any = '';
  UserRole: any = '';
  dr: any = '';
  np: any = '';
  @ViewChild('scrollCaptureInsurance', { static: false }) private myScrollContainer: ElementRef;
  @ViewChild('fileBack') fileBackInput!: ElementRef;
  constructor(private _intakeMedicationService: IntakeMedicationService, private smarty: SmartyAddressService, private translateService: TranslateService, private _insuranceservice: InsuranceService, private _insuranceservicePhase2: InsurancePhase2Service, private _phrutilService: PhrutillsService, private UpdateinfoService: UpdateinfoService,
    private spinner: NgxSpinnerService, private datepipe: DatePipe, private router: Router, private _VerifypatientService: VerifypatientService) {
    let info = localStorage.getItem('PersonalInfo');
    if (!info) {
      this.router.navigateByUrl("/");
      return;
    }
    this.searchinsurancemodel = new SearchInsuranceModel();
    this._addpatientinsurancemodel = new AddInsuranceModel();
    this.searchinsuranceresponce = new SerchInsuranceResponceModel();
    this.UpdateInsuranceModel = new UpdateInsuranceModel();
    this._updatesubscriberinfo = new UpdateSubscriberInfo();
    this._guarantor = new AddSubscriberResponse();
    //this.CityandStateRequest = new CityandStateRequest();
    this.getSubscriberDetails = new getSubscriberDetails();
    this.defaultImagefront = 'assets/images/card-front.png';
    this.defaultImageback = 'assets/images/card-back.png';
    let pagesorder = localStorage.getItem('pagesorder');
    this.pageNum = JSON.parse(pagesorder ? pagesorder : '').insurance;
    this.totalPages = localStorage.getItem('totalPages');
  }

  ngOnInit(): void {
    //const testData = { foo: "bar", num: 123 };
    //const encrypted = this._phrutilService.encryptforAI(testData);

    // Now test decryption:
    // const decrypted = this._phrutilService.decryptforAI(encrypted.encrypted_data, encrypted.iv);
    // console.log(decrypted); // Should match testData
    this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PersonalInfo'));
    // console.log(this.patientpersonalinfo);
    const state = localStorage.getItem('state')

    if (state != undefined && state !=null) {
      this.practiceState = state;
    }
    const city = localStorage.getItem('city')
    if (city != undefined && city != null) {
      this.practiceCity = city;
    }
    const appstID = localStorage.getItem('apptstId');
    const apptid = localStorage.getItem("apptId");
    if (apptid != undefined && apptid != null && apptid != '') {
      this.appointmentId = apptid
    } else {
      this.appointmentId = '';
    }
    /*
    const insStatus = localStorage.getItem('insStatus');
    console.log("insurance status ", insStatus);
    const pcpStatus = localStorage.getItem('pcpStatus');
    console.log("pcp status from localstorage ", pcpStatus);
    if (pcpStatus != undefined && pcpStatus != null && pcpStatus.trim() !== '') {
      console.log("pcp status inside ", pcpStatus);
      this.pcpStatus = pcpStatus.toLowerCase();

      // Check if the pcpStatus is 'pcp mismatch' and set notification
      if (this.pcpStatus == 'pcp mismatch') {
        this.notificationCount = 1;
        this.showNotificationIcon = true;
      } else {
        this.showNotificationIcon = false;
      }
    } else {
      // Clear the pcpStatus and hide notification if invalid
      this.pcpStatus = '';
      this.showNotificationIcon = false;

      console.log("pcp status inside else - pcpStatus: ", pcpStatus);
      console.log("pcp status inside else - this.pcpStatus: ", this.pcpStatus);
    }
    */


    /*
    if (insStatus != undefined && insStatus != null && insStatus != '') {
      console.log("insurance status inside ", insStatus);
      this.insuranceStatus = insStatus.toLowerCase();
      if (this.insuranceStatus == 'rejected' || this.insuranceStatus == 'inactive') {
        this.isPrimaryInsuranceInactive = true;
      } else {
        this.isPrimaryInsuranceInactive = false;
      }
      console.log("insurance status ", this.insuranceStatus);
    } else {
      this.insuranceStatus = '';
      this.isPrimaryInsuranceInactive = false;
    }
  */
    this.GetPatientInsuranceInfo(this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE, this.appointmentId);
    this.maxDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.translateService.get('button.add').subscribe((translation: string) => {
      this.subSAction = translation;
    });
    this.translateService.get('button.add').subscribe((translation: string) => {
      this.insurancetype = translation;
    });
    this._phrutilService.patientlanguage$.subscribe(language => {
      console.log("dafault " + language);
      if (language === 'es') {
        this._phrutilService.setTitle('Seguro');
      } else if (language === 'hi'){
        this._phrutilService.setTitle('बीमा');
      }
      else if (language === 'ur') {
        this._phrutilService.setTitle('انشورنس');
      }
      else {
        this._phrutilService.setTitle('Insurance');
      }
    });
    console.log("appointemtn status id ", appstID);
    if (appstID != '2') {
      this.UpdateAppointmentstatus();
    }
    this.providerLname = localStorage.getItem("pln");
    this.providerFname = localStorage.getItem("pfn");
    this.UserRole = localStorage.getItem("role");
    if (this.UserRole === "Provider") {
      this.dr = this.patientpersonalinfo.PRACTICE_CODE == '1013886' ? 'Mr. ' : 'Dr. ';
    } else if (this.UserRole === "N.P/P.A") {
      this.np = ', NP';
    }

  }
  showNotification() {
    console.log("notification clicked");
    $('#notofication-modal').modal('show');
  }

  UpdatePatientSelfPayBit(type: any) {
    // if (this.isInsurance || this.isSelfPay) {
    //$('#notofication-modal').modal('show');
    //return;
    this.spinner.show();
    this.UpdatePatientSelfPayBitRequest.patientAccount = this.patientpersonalinfo.PATIENT_ACCOUNT;
    this.UpdatePatientSelfPayBitRequest.practiceCode = this.patientpersonalinfo.PRACTICE_CODE;
    this.UpdatePatientSelfPayBitRequest.isSelfPay = type == 'selfpay' ? 'true' : 'false';
    this._insuranceservicePhase2.UpdatePatientSelfPayBit(this.UpdatePatientSelfPayBitRequest).subscribe((res: any) => {

      this.spinner.hide();
      if (res.statusCode == 200 && res.message.toLowerCase() == 'success') {
        if (this.UpdatePatientSelfPayBitRequest.isSelfPay == 'true') {
          localStorage.setItem("backFromCovid", "false");
          this.router.navigateByUrl('patient/intake');
        }
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);

      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);

    });
  }

  gotoFirstScreen() {
    this.noInsuranceScreen = true,
      this.addInsurance = false
  }

  // Method to scroll to the second input field (back photo input)
  scrollToBackInput(): void {
    //console.log("backFileElement",this.fileBackInput);
    if (this.fileBackInput) {
      this.fileBackInput.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  AppointmentStatusConfirmed: any;
  UpdateAppointmentstatus() {
    // this.spinner.show();
    //console.log("status update started");
    const apptid = localStorage.getItem("apptId");
    this.AppointmentStatusConfirmed = 2;
    this._VerifypatientService.ConfirmAppointment(apptid, this.AppointmentStatusConfirmed).subscribe((res: any) => {
      //console.log(res)
      if (res.message == "Record Updated") {
        console.log("status update completed");
        localStorage.setItem("updateAppointmentStatus", "true")
      } else {
        console.log("status update failed");
        localStorage.setItem("updateAppointmentStatus", "false")
      }
    })
  }

  dNoneInsurance: boolean = true;
  insuranceNamePopup: any;
  insuranceNamemain: any;
  PatientInsuranceSearch(str: any, type: any) {
    this.insName_Id = '';
    // if (str.keyCode == 8) {
    if (!str.target.value || str.target.value.length < 3) {
      this.isLoading = false;
      this.filterInsuranceSearch = [];
      this.isInsuranceData = false;
      this.dNoneInsurance = true;
      this.insuranceNameError = false;
      return false;
    }
    this.dNoneInsurance = false;
    // }
    this.searchinsurancemodel.patientAccount = this.patientpersonalinfo.PATIENT_ACCOUNT;
    this.searchinsurancemodel.practiceCode = this.patientpersonalinfo.PRACTICE_CODE;
    this.searchinsurancemodel.groupName = "";
    this.searchinsurancemodel.zip = "";
    this.searchinsurancemodel.pageIndex = "1";
    this.searchinsurancemodel.pageSize = "20";
    this.searchinsurancemodel.patientState = this.patientpersonalinfo.STATE ? this.patientpersonalinfo.STATE : '';
    this.searchinsurancemodel.flag = "";
    this.searchinsurancemodel.callFrom = this.selectedState;
    this.searchinsurancemodel.providerCode = "";
    this.searchinsurancemodel.insuranceName = str.target.value;
    if (type == 'main') {
      this.insuranceNamemain = str.target.value;
    }
    else {
      this.insuranceNamePopup = str.target.value;
    }

    if (str) {
      if (str.keyCode == 40 || str.keyCode == 39 || str.keyCode == 38 || str.keyCode == 37) {
        return false;
      }
      this.isLoading = true;
      //this.spinner.show();
      this._insuranceservice.SearchPatientInsurance(this.searchinsurancemodel).subscribe((res: any) => {
        //this.spinner.hide();
        this.isInsuranceData = true;
        this.isLoading = false;
        if (res) {
          if (res.statusCode == 200) {
            this.filterInsuranceSearch = res.data;
            this.filterInsuranceSearch.map((res1: any) => {
              res1.insurancE_ZIP = this._phrutilService.maskingZipNum(res1.insurancE_ZIP);
            })
            objectCopyInsurance = this.filterInsuranceSearch;
          }
        }
      },
        (error: any) => {
          //this.spinner.hide();
          this.isInsuranceData = true;
          this.isLoading = false;
          this.filterInsuranceSearch = [];
          //this._phrutilService.showError("Service is not available, please try later.");
        })
    }
    return true;
  }
  insuranceDescriptionOCR: any = "";
  insName_Id: string = '';
  isShowField: boolean = false;
  SetInsuranceSearch($event: any, type: any) {

    if ($event) {

      var all = objectCopyInsurance.filter((x: any) => x.inspayeR_DESCRIPTION.toLowerCase() == $event.toLowerCase());
      if (all != undefined && all != null && all.length > 0) {
        this.searchinsuranceresponce = all[0];
        this.insName_Id = this.searchinsuranceresponce.insName_Id;
        this._addpatientinsurancemodel.groupName = this.searchinsuranceresponce.grouP_NAME;
        this._addpatientinsurancemodel.groupId = this.searchinsuranceresponce.grouP_ID;
        this._addpatientinsurancemodel.insuranceId = this.searchinsuranceresponce.insurancE_ID;
        this.UpdateInsuranceModel.insuranceId = this.searchinsuranceresponce.insurancE_ID;
        this.searchinsurancemodel.insuranceName = $event;
        this.insuranceDescriptionOCR = $event;
        this.isShowField = true;
        this.insuranceNamePopup = $event;
        this.insuranceNamemain = '';
        if (type == 'main') {
          this.translateService.get('button.add').subscribe((translation: string) => {
            this.insurancetype = translation;
          });
          //this.insurancetype = "Add";
          this.insurancemodel = false;
        }
        else if (type == 'popup') {

        }
        this.add_insurance_manual();

      }
    }
  }
  validateInsuranceinfo(field: any, type: any) {
    if (type === "groupid") {
      let num = field.value.replace(/\D/g, '');
      field.value = num;
      this._addpatientinsurancemodel.groupId = num;
    } else
      if (type === "policyid") {
        let num = field.value.replace(/\D/g, '');
        field.value = num;
        this._addpatientinsurancemodel.policyNumber = num;
      }
  }

  dNoneAddress: boolean = true;

  SearchAdressBySmartyAPi(str: any) {
    //console.log(str.target.value);
    if (str.target.value.length > 3) {
      this.isLoading = true;
      this.dNoneAddress = this._updatesubscriberinfo.guaranT_ADDRESS?.length > 0 ? false : true;
      this.smarty.getAutoCompleteSuggestions(str.target.value, this.practiceState, this.practiceCity).then((res: any) => {
        this.addressOptions = res as any[];
        // console.log(this.addressOptions);
        this.isLoading = false;
      })
    }
  }
  setAddressOption(item: any) {
    // console.log(item);
    this._updatesubscriberinfo.guaranT_STATE = item.state;
    this._updatesubscriberinfo.guaranT_CITY = item.city;
    this.onFocusOutZIPSubsciber(item.zipcode, 1)
    this._updatesubscriberinfo.guaranT_ADDRESS = item.streetLine;
  }

  ShowSubscriberForm(type: any) {

    if (type == undefined || type.target.value != "S") {
      this.isShowSubscriberForm = true;
      this._addpatientinsurancemodel.subscriber = '';
      this._addpatientinsurancemodel.guarantoR_CODE = '';
      this._updatesubscriberinfo = new UpdateSubscriberInfo();
      $('#Insurance-Modal').modal('hide');
      $('#Subscriber-Modal').modal('show');
      this.translateService.get('button.add').subscribe((translation: string) => {
        this.subSAction = translation;
      });
      // this.subSAction="Add";
    }
    else {
      this.isShowSubscriberForm = false;
      this._addpatientinsurancemodel.subscriber = '';
      this._addpatientinsurancemodel.guarantoR_CODE = '';
      this.subcriberReq = false;
      this._updatesubscriberinfo = new UpdateSubscriberInfo();
      $('#Subscriber-Modal').modal('hide');
    }


  }
  ShowSubscriberButton(type: any) {
    if (type == undefined || type.target.value != "S") {
      if ((this._addpatientinsurancemodel.subscriber && this._addpatientinsurancemodel.guarantoR_CODE) || (this._updatesubscriberinfo.guaranT_FNAME && this._updatesubscriberinfo.guaranT_LNAME)) {
        return;
      }
      else {
        this.isShowSubscriberForm = true;
      }
    }
    else {
      this.isShowSubscriberForm = false;
      this._addpatientinsurancemodel.subscriber = '';
      this._addpatientinsurancemodel.guarantoR_CODE = '';
      this.subcriberReq = false;
      this._updatesubscriberinfo = new UpdateSubscriberInfo();
    }
  }
  validateName(inputName: any, type: any, name: any) {
    this._firstNameReq = false;
    this._lastNameReq = false;
    let validname = "";
    if (inputName.value.trim()) {
      validname = inputName.value.replace(/[^a-zA-Z ]/g, "");
      inputName.value = validname;
    }
    else {
      inputName.value = inputName.value.trim();
    }
    if (type === "subscriber") {
      if (name === 'first') {
        this._updatesubscriberinfo.guaranT_FNAME = validname;
      }
      else
        if (name === 'last') {
          this._updatesubscriberinfo.guaranT_LNAME = validname;
        }
    }

  }
  onFocusOutCity(event: any) {

    let data = event.target.value;
    this._cityandstateList.map((res: any) => {
      if (res.cityName == data) {
        this._updatesubscriberinfo.guaranT_CITY = res.cityName;
        this._updatesubscriberinfo.guaranT_STATE = res.stateCode;
      }
    })
  }
  onFocusOutZIPSubsciber(event: any, type: any) {

    let zipcode;
    if (type == 1) {
      zipcode = event.replace(/\D/g, '');
      zipcode = this._phrutilService.maskingZipNum(zipcode);
      this._updatesubscriberinfo.guarant_zip = zipcode;
    } else {
      let phoneNumDigits = event.value.replace(/\D/g, '');
      phoneNumDigits = this._phrutilService.maskingZipNum(phoneNumDigits);
      event.value = phoneNumDigits;
      zipcode = event.value;
      this._updatesubscriberinfo.guarant_zip = zipcode;
    }
    zipcode = zipcode.replace(/\D/g, '');
    this._cityandstateList = [];
    if (zipcode && (zipcode.length == 5 || zipcode.length == 9)) {

      this.spinner.show();
      //this.CityandStateRequest.ZIP_CODE = zipcode;
      this.UpdateinfoService.getZipCityState(zipcode, this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE).subscribe((res: any) => {

        this.spinner.hide();
        if (res.data && res.data.length > 0) {
          this.isZipCodeNotValidSuubscriberInfo = false;
          this._cityandstateList = res.data;
          if (type == 0) {
            this._updatesubscriberinfo.guaranT_CITY = this._cityandstateList[0].cityName;
            this._updatesubscriberinfo.guaranT_STATE = this._cityandstateList[0].stateCode;
          } else
            if (type == 1) {
              this._cityandstateList.map((res: any) => {
                if (res.cityName.trim() == this._updatesubscriberinfo.guaranT_CITY.trim())
                  this._updatesubscriberinfo.guaranT_CITY = res.cityName.trim();
                if (res.stateCode.trim() == this._updatesubscriberinfo.guaranT_STATE.trim())
                  this._updatesubscriberinfo.guaranT_STATE = res.stateCode.trim();
              });
            }
        } else {
          this.isZipCodeNotValidSuubscriberInfo = true;
          this.zipLengthReq = true;
          this._updatesubscriberinfo.guaranT_CITY = "";
          this._updatesubscriberinfo.guaranT_STATE = "";
        }
        $('#Subscriber-Modal').modal('show');
      },
        (error: any) => {
          this.isZipCodeNotValidSuubscriberInfo = true;
          this.zipLengthReq = true;
          this._updatesubscriberinfo.guaranT_CITY = "";
          this._updatesubscriberinfo.guaranT_STATE = "";
          this.spinner.hide('Subscriberinfospinner');
          $('#Subscriber-Modal').modal('show');
        })
    }
    else {
      $('#Subscriber-Modal').modal('show');
      this._cityandstateList = [];
      this._updatesubscriberinfo.guaranT_CITY = "";
      this._updatesubscriberinfo.guaranT_STATE = "";
    }
  }
  keyPressNumbers(event: any) {
    this._phrutilService.keyPressNumbers(event);
  }
  ValidateAddress(inputName: any, type: any, name: any) {
    this.addressReq = false;
    let validname = inputName.value.replace(/[^/#.0-9a-zA-Z\s,-]/g, "");
    inputName.value = validname;
    if (type === "subscriber") {
      this._updatesubscriberinfo.guaranT_ADDRESS = validname;
    }
  }
  ResetSubscriberData() {
    if (!this._updatesubscriberinfo.guarantoR_CODE) {
      this._firstNameReq = false;
      this._lastNameReq = false;
      this.subcriberReq = false;
      this.addressReq = false;
      this.zipReq = false;
      this.zipLengthReq = false;
      this.isDateError = false;
      this._updatesubscriberinfo = new UpdateSubscriberInfo();
      // this.closeCaptureCard('reset');
    }
    if (this._updatesubscriberinfo.guarant_dob && this._updatesubscriberinfo.guarant_dob.length != '') {
      this._updatesubscriberinfo.guarant_dob = this.datepipe.transform(this._updatesubscriberinfo.guarant_dob, 'MM/dd/yyyy');
    }
  }
  CloseSubscriberModel() {
    $('#Subscriber-Modal').modal('hide');
    // $('#Insurance-Modal').modal('show');
    this.addInsurance = true;
  }
  ValidateSubscriber() {
    this._updatesubscriberinfo.guarant_zip = this._updatesubscriberinfo.guarant_zip.replace(/\D/g, '');
    if (this._updatesubscriberinfo.guarant_zip == '' || this._updatesubscriberinfo.guarant_zip == undefined || this._updatesubscriberinfo.guarant_zip == null) {
      this._updatesubscriberinfo.guarant_zip = '';
      this._updatesubscriberinfo.guaranT_CITY = '';
      this._updatesubscriberinfo.guaranT_STATE = '';
    }
    if (this._updatesubscriberinfo.guaranT_FNAME == "" || this._updatesubscriberinfo.guaranT_FNAME.trim().length <= 0 || this._updatesubscriberinfo.guaranT_FNAME == undefined) {
      this._firstNameReq = true;
      return false;
    }
    else {
      this._firstNameReq = false;
    }
    if (this._updatesubscriberinfo.guaranT_LNAME == "" || this._updatesubscriberinfo.guaranT_LNAME.trim().length <= 0 || this._updatesubscriberinfo.guaranT_LNAME == undefined) {
      this._lastNameReq = true;
      return false;
    }
    else {
      this._lastNameReq = false;
    }


    if (this.isDateError) {
      return false;
    }
    if (this._updatesubscriberinfo.guaranT_ADDRESS == "" || this._updatesubscriberinfo.guaranT_ADDRESS.trim().length <= 0 || this._updatesubscriberinfo.guaranT_ADDRESS == undefined) {
      this.addressReq = true;
      return false;
    }
    else {
      this.addressReq = false;
    }
    if (this._updatesubscriberinfo.guarant_zip == "" || this._updatesubscriberinfo.guarant_zip.trim().length <= 0 || this._updatesubscriberinfo.guarant_zip == undefined) {
      this.zipReq = true;
      return false;
    }
    else {
      this.zipReq = false;
    }
    if (this._updatesubscriberinfo.guarant_zip.length > 0 && (this._updatesubscriberinfo.guarant_zip.length != 5 && this._updatesubscriberinfo.guarant_zip.length != 9)) {
      this.isZipCodeNotValidSuubscriberInfo = true;
      return false;
    }
    else {
      this.zipLengthReq = false;
    }

    if (!this.isZipCodeNotValidSuubscriberInfo) {
      if (!this._updatesubscriberinfo.guarant_zip) {
        this.zipReq = true;
        return false;
      }

      else {
        this.zipReq = false;
      }
    } else {
      return false;
    }

    this._addpatientinsurancemodel.subscriber = this._updatesubscriberinfo.guaranT_FNAME + ' ' + this._updatesubscriberinfo.guaranT_LNAME;
    if (this._updatesubscriberinfo.guarant_dob && this._updatesubscriberinfo.guarant_dob.length != '') {
      this._updatesubscriberinfo.guarant_dob = this.datepipe.transform(this._updatesubscriberinfo.guarant_dob, 'MM/dd/yyyy');
    }

    this.subcriberReq = true;
    $('#Subscriber-Modal').modal('hide');
    //$('#Insurance-Modal').modal('show');
    this.addInsurance = true;
    this.InsuranceDetails = false;
    this.isShowSubscriberForm = false;
    return true;
  }
  AddinsuranceBycard: boolean = true;
  addInsurancemanually: boolean = false;

  addInsuranceManuallyNew() {
    this.filterInsuranceSearch = [];
    this.dNoneInsurance = true;
    this.insuranceNamePopup = '';
    this.insuranceNamemain = '';
    this.ClearInsuranceInfo();
    this.insurancemodel = false;
    this.addInsurance = true;
    this.InsuranceDetails = false;
    this.addInsurancemanually = true;
    this.AddinsuranceBycard = false;
    this.searchinsuranceresponce.insurancE_ID = '';
    this._addpatientinsurancemodel.relationship = 'S';
    const insurancetype = localStorage.getItem("itype")
    console.log("istype " + insurancetype);

    if (this.isPrimaryInsuranceInactive == true) {
      this.insurancecat = 'P';
    } else {
      if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'S')) {
        this.insurancecat = 'O';

      } else if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P')) {
        this.insurancecat = 'S';

      } else {
        this.insurancecat = 'P';

      }
    }
  }

  addInsuranceManuallyBycard() {
    //  this.filterInsuranceSearch = [];
    //  this.dNoneInsurance = true;
    this.insuranceNamemain = '';
    //this.ClearInsuranceInfo();
    this.insurancemodel = false;
    this.addInsurance = true;
    this.InsuranceDetails = false;
    this.addInsurancemanually = true;
    this.AddinsuranceBycard = false;
    //   this.searchinsuranceresponce.insurancE_ID = '';
    this._addpatientinsurancemodel.relationship = 'S';
    const insurancetype = localStorage.getItem("itype")
    console.log("istype " + insurancetype);

    if (this.isPrimaryInsuranceInactive == true) {
      this.insurancecat = 'P';
    } else {
      if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'S')) {
        this.insurancecat = 'O';

      } else if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P')) {
        this.insurancecat = 'S';

      } else {
        this.insurancecat = 'P';

      }
    }
  }


  InsuranceDetailsNew() {
    this.InsuranceDetails = true;
    this.addInsurance = false;
    this.AddinsuranceBycard = false;
    this.addInsurancemanually = false;
    this._addpatientinsurancemodel.insuranceId = '';
    //this.fileObjFront = '';
    //this.fileObjBack = '';
    localStorage.setItem("alreadyUpload", 'false');
  }
  addInsuranceBycard() {
    this.ClearInsuranceInfo();
    this.filterInsuranceSearch = [];
    this.dNoneInsurance = true;
    this.searchinsuranceresponce.insurancE_ID = '';
    this.fileObjFront = '';
    this.fileObjBack = '';
    this.AddinsuranceBycard = true;
    this.addInsurancemanually = false;
    this.isFrontPhotoUpload = false;
    this.isbackPhotoUpload = false;
    this.isRequireFrontCard = false;
    this.isRequireBackCard = false;
    this.insurancemodel = false;
    this.addInsurance = true;
    this.InsuranceDetails = false;
    this.noInsuranceScreen = false;
    const insurancetype = localStorage.getItem("itype")
    console.log("itype " + insurancetype);

    if (this.isPrimaryInsuranceInactive == true) {
      this.insurancecat = 'P';
    } else {
      if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'S')) {

        this.insurancecat = 'O';

      } else if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P')) {

        this.insurancecat = 'S';

      } else {

        this.insurancecat = 'P';

      }
    }

  }

  showUploadedPhoto() {
    const frontImage = localStorage.getItem("photofront");
    const backImage = localStorage.getItem("photoback");
    //console.log(frontImage);
    if (frontImage && backImage) {
      if (frontImage) {
        this.isFrontPhotoUpload = true;
        this.isRequireFrontCard = false;
        this.defaultImagefront = frontImage; // Set the image preview
      }

      if (backImage) {
        this.isbackPhotoUpload = true;
        this.isRequireBackCard = false;
        this.defaultImageback = backImage; // Set the image preview
      }
    } else {
    }

  }

  mainInsuranceNew() {
    if (this.isPrimaryInsuranceInactive == false) {
      if (this._insurances.length == 3) {
        let text = "You cannot add more then 3 insurance";
        this.translateService.get('Alerts.insurance_moreThan_3').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        return;
      }
      this.addInsuranceBycard();
    } else {
      this.addInsuranceBycard();
    }

    //this.addInsuranceManuallyNew();

  }
  /* ClickInsuranceInfo(cat: any, isAddInsurance: any) {
    //cat for insurance category (P,S,O)
    //isAddInsurance is to identify this method is call from update insurance or add insuarnce (true/false)
    if (isAddInsurance) {
      this.selectInsurance(cat);
    }
    if (cat == 'P') {
      if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P')) {
        //console.log("P exists");
      } else {
        this.insurancecat = cat;
      }     
    }
    else
      if (cat == 'S') {
        if (isAddInsurance) {
          //console.log("cat s");
          if (this.isPrimeryInsuranceAvailable()) {
            if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'S')) {
             // console.log("s exists");
            } else {
              this.insurancecat = cat;
            }
          }
          else {
            this.ToggleInsuranceModel(false);
          }
        }
        else {
          this.insurancecat = cat;
        }
      }
      else
        if (cat == 'O') {
          if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'O')) {
            //console.log("O exists");
          } else {
            this.insurancecat = cat;
          }
        }
        else {
          this.insurancecat = 'P';
        }

  } */

  ClickInsuranceInfo(cat: any, isAddInsurance: any) {
    //cat for insurance category (P,S,O)
    //isAddInsurance is to identify this method is call from update insurance or add insuarnce (true/false)
    if (cat == 'P') {
      this.insurancecat = cat;
    }
    else
      if (cat == 'S') {
        if (isAddInsurance) {
          if (this.isPrimeryInsuranceAvailable()) {
            this.insurancecat = cat;
          }
          else {
            this.ToggleInsuranceModel(false);

          }
        }
        else {

          this.insurancecat = cat;
        }
      }
      else
        if (cat == 'O') {
          this.insurancecat = cat;
        }
        else {
          this.insurancecat = 'P';
        }

  }


  ToggleInsuranceModel(ishowInsuranceModel: any) {
    if (ishowInsuranceModel) {
      $("#PrimeryinsuranceNotAvailable").modal("hide");
      //$("#Insurance-Modal").modal("show");
      this.addInsurance = true;
      this.AddinsuranceBycard = true;
      this.addInsurancemanually = false;
      this.addInsuranceBycard();
    }
    else {
      $("#PrimeryinsuranceNotAvailable").modal("show");
      $("#Insurance-Modal").modal("hide");
    }
  }

  isPrimeryInsuranceAvailable() {

    if (this._insurances.map(res => res.prI_SEC_OTH_TYPE == 'P')?.length > 0) {
      return true;
    }
    else {
      return false;
    }

  }

  GetPatientInsuranceInfo(patientAccount: any, practiceCode: any,appointmentId:any) {
    this.spinner.show();
    this._insuranceservice.GetPatientInsuranceInfo(patientAccount, practiceCode, appointmentId).subscribe((res: any) => {

      this.spinner.hide();
      if (res.statusCode == 200) {
        this._insurances = res.data as PatienT_INSURANCE_INFO[];
        //console.log(this._insurances.length);
        if (this._insurances.length > 0) {
          this.InsuranceDetailsNew();
          const newIns = localStorage.getItem("newIns");
          // console.log("new insurance", newIns);
          if (newIns != null)
            this.newPrimaryInsuranceAdded = newIns;
          if (this.newPrimaryInsuranceAdded == false) {
            if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P')) {
              this.isPrimaryInsurancealredyExist = true;
              const status = this._insurances.find(res => res.prI_SEC_OTH_TYPE === 'P')
              this.insuranceStatus = status?.insurancE_STATUS;
              this.pcpStatus = status?.pcP_STATUS;
              //this.pcpStatus = 'pcp mismatch';
              // console.log("insurance status ", this.insuranceStatus);
              // console.log("PCP status ", this.pcpStatus);
              if (this.insuranceStatus != undefined && this.insuranceStatus != null && this.insuranceStatus != '') {

                this.insuranceStatus = this.insuranceStatus.toLowerCase();
                if (this.insuranceStatus == 'rejected' || this.insuranceStatus == 'inactive') {
                  this.isPrimaryInsuranceInactive = true;
                } else {
                  this.isPrimaryInsuranceInactive = false;
                }
                // console.log("insurance status ", this.insuranceStatus);
              } else {
                this.insuranceStatus = '';
                this.isPrimaryInsuranceInactive = false;
              }

              if (this.pcpStatus != undefined && this.pcpStatus != null && this.pcpStatus.trim() !== '') {
                // console.log("pcp status inside ", this.pcpStatus);
                this.pcpStatus = this.pcpStatus.toLowerCase();

                if (this.pcpStatus == 'pcp mismatch') {
                  this.notificationCount = 1;
                  this.showNotificationIcon = true;
                  // $('#notofication-modal').modal('show');

                } else {
                  this.showNotificationIcon = false;
                  // $('#notofication-modal').modal('hide');
                }
              } else {
                this.pcpStatus = '';
                this.showNotificationIcon = false;
                // $('#notofication-modal').modal('hide');
              }
            } else {
              this.isPrimaryInsuranceInactive = false;
              this.showNotificationIcon = false;
              //$('#notofication-modal').modal('hide');
            }
          }


          //this.InsuranceDetails = true;
          //this.addInsurance = false;
          //this.AddinsuranceBycard = false;
          //this.addInsurancemanually = false;
        } else {
          if (this.isphotoupload) {
            this.nextClick()
          } else {
            this.InsuranceDetails = false;
            //this.addInsurance = true;
            this.noInsuranceScreen = true;
            this.isPrimaryInsuranceInactive = false;
            this.showNotificationIcon = false;
            localStorage.setItem("insStatus", '');
            //this.addInsuranceBycard();
            let isAlreadyPhotoUpload = localStorage.getItem('alreadyUpload');
            if (isAlreadyPhotoUpload=='true')
              this.showUploadedPhoto();
          }

        }

        this._insurances.map((res: any) => {

          if (res.inspayeR_DESCRIPTION.toLowerCase().includes("medicare") ||
            res.inspayeR_DESCRIPTION.toLowerCase().includes("cigna") ||
            res.inspayeR_DESCRIPTION.toLowerCase().includes("aetna medicare") ||
            res.inspayeR_DESCRIPTION.toLowerCase().includes("railroad")) {

            res.is_OCR_exist = true;
          }
          else {
            res.is_OCR_exist = false;
          }

        })


      } else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      }

    },
      (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      })
  }
  policyNumberError: boolean = false;
  insurance_type: string = '';
  Add_Insurance_Info_confirmation_model() {
    //console.log(this.fileArray.length);
    //console.log(this.isRequireFrontCard);
    //console.log(this.searchinsuranceresponce.insurancE_ID,"searched insurance id");
    //console.log(this._addpatientinsurancemodel.insuranceId,"ocr insurance id");
    const insuranceId = this.searchinsuranceresponce.insurancE_ID ? this.searchinsuranceresponce.insurancE_ID :this._addpatientinsurancemodel.insuranceId;
    const isInsuranceAlredyExist = this._insurances.some((insurance) => {
      return insurance.insurancE_ID === insuranceId;
    });
    if (isInsuranceAlredyExist) {
      //console.log(isInsuranceAlredyExist,"is exist")
      //console.log(insuranceId,"ins id")
      //console.log(this.searchinsuranceresponce,"ins response")
      let text = "This insurance is already exist.";
      this.translateService.get('insurances.insurance_alredy_exist').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showInfo(text);
      //this._phrutilService.showInfo("This insurance is already exist.");
      return false;
    }
    if (!this._addpatientinsurancemodel.insuranceId && !this.UpdateInsuranceModel.insuranceId) {
      this.insuranceNameError = true;
      return false;
    }
    else {
      this.insuranceNameError = false;
    }
    if (this._addpatientinsurancemodel.policyNumber == "" || this._addpatientinsurancemodel.policyNumber == null || this._addpatientinsurancemodel.policyNumber == undefined) {
      this.policyNumberError = true;
      return false;
    } else {
      this.policyNumberError = false;
    }
    if (this.insurancecat == undefined) {
      this.insurancecat = 'P';
      this._addpatientinsurancemodel.type = this.insurancecat;
    }
    else
      this._addpatientinsurancemodel.type = this.insurancecat;

    if (this._addpatientinsurancemodel.relationship != "S") {
      if (!this.subcriberReq && (this._addpatientinsurancemodel.subscriber == undefined || this._addpatientinsurancemodel.subscriber == null || this._addpatientinsurancemodel.subscriber.length == 0)) {
        let text = "Select Relation as 'Self' or add Subscriber";
        this.translateService.get('Alerts.insurance_select_relation_as_self').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("Select Relation as 'Self' or add Subscriber");
        return false;
      }
    }

    $("#Insurance-Modal").modal("hide");
    // $("#insurancesavemodal").modal("show");
    this.Addinsurance();
    return true;
  }
  noAgree() {
    this.addInsurance = true;
    this.addInsuranceManuallyNew();
    //$("#Insurance-Modal").modal("show");
  }
  Addinsurance() {
    let idList = [];
    if (this._insurances)
      for (let checklimit of this._insurances) {
        idList.push(checklimit.id);
      }
    // Check Save Update
    if (this.insurancemodel == false) {
      if (idList.length >= 3 && this.insurancemodel == false) {
        let text = "You cannot add more then 3 insurance";
        this.translateService.get('Alerts.insurance_moreThan_3').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("You cannot add more then 3 insurance");
      } else
        if (idList.length == 2) {
          if (idList[0] == '1' && idList[1] == '2') {
            if (this.insurancecat === 'P' && this.isPrimaryInsuranceInactive == false) {
              let text = "You can only add one primary insurance";
              this.translateService.get('Alerts.insurance_only_add_one_primary').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showInfo(text);
              //this._phrutilService.showInfo("You can only add one primary insurance");
            } else if (this.insurancecat === 'S') {
              let text = "You can only add one secondary insurance";
              this.translateService.get('Alerts.insurance_only_add_one_secondary').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showInfo(text);
              //this._phrutilService.showInfo("You can only add one secondary insurance");
            } else {
              if (this.insurancemodel)
                this.Update_Insurance_Info();
              else
                this.Add_insurance_info();
            }
          } else
            if (idList[0] == '1' && idList[1] == '3') {
              if (this.insurancecat === 'P'&& this.isPrimaryInsuranceInactive == false) {
                let text = "You can only add one primary insurance";
                this.translateService.get('Alerts.insurance_only_add_one_primary').subscribe((translation: string) => {
                  text = translation;
                });
                this._phrutilService.showInfo(text);
                //this._phrutilService.showInfo("You Can Only Add One Primary Insurance");
              } else if (this.insurancecat === 'O') {
                let text = "You Can Only Add One Other Insurance";
                this.translateService.get('Alerts.insurance_only_add_one_other').subscribe((translation: string) => {
                  text = translation;
                });
                this._phrutilService.showInfo(text);
                //this._phrutilService.showInfo("You Can Only Add One Other Insurance");
              } else {
                if (this.insurancemodel)
                  this.Update_Insurance_Info();
                else
                  this.Add_insurance_info();
              }
            } else
              if (idList[0] == '2' && idList[1] == '3') {
                if (this.insurancecat === 'S') {
                  let text = "You can only add one secondary insurance";
                  this.translateService.get('Alerts.insurance_only_add_one_secondary').subscribe((translation: string) => {
                    text = translation;
                  });
                  this._phrutilService.showInfo(text);
                  //this._phrutilService.showInfo("You Can Only Add One Secondary Insurance");
                } else if (this.insurancecat === 'O') {
                  let text = "You Can Only Add One Other Insurance";
                  this.translateService.get('Alerts.insurance_only_add_one_other').subscribe((translation: string) => {
                    text = translation;
                  });
                  this._phrutilService.showInfo(text);
                  // this._phrutilService.showInfo("You Can Only Add One Other Insurance");
                } else {
                  if (this.insurancemodel)
                    this.Update_Insurance_Info();
                  else
                    this.Add_insurance_info();
                }
              }
        }
        else
          if (idList.length == 1) {
            if (idList[0] == '1' && this.insurancecat === 'P' && this.isPrimaryInsuranceInactive == false) {
              let text = "You can only add one primary insurance";
              this.translateService.get('Alerts.insurance_only_add_one_primary').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showInfo(text);
              // this._phrutilService.showInfo("You can only add one primary insurance");
            } else
              if (idList[0] == '2' && this.insurancecat == 'S') {
                let text = "You can only add one secondary insurance";
                this.translateService.get('Alerts.insurance_only_add_one_secondary').subscribe((translation: string) => {
                  text = translation;
                });
                this._phrutilService.showInfo(text);
                //this._phrutilService.showInfo("You can only add one secondary insurance");
              } else
                if (idList[0] == '3' && this.insurancecat === 'O') {
                  let text = "You Can Only Add One Other Insurance";
                  this.translateService.get('Alerts.insurance_only_add_one_other').subscribe((translation: string) => {
                    text = translation;
                  });
                  this._phrutilService.showInfo(text);
                  // this._phrutilService.showInfo("You can only add one Other insurance");
                } else {
                  if (this.insurancemodel)
                    this.Update_Insurance_Info();
                  else
                    this.Add_insurance_info();
                }
          }
          else {
            if (this.insurancemodel == false) {
              if (this.insurancemodel)
                this.Update_Insurance_Info();
              else
                this.Add_insurance_info();
            }
            else {
              if (this.insurance_type == this.insurancecat) {
                if (this.insurancemodel)
                  this.Update_Insurance_Info();
                else
                  this.Add_insurance_info();
              } else {
                let text = "You Can Only Add One Other Insurance";
                this.translateService.get('Alerts.insurance_only_add_one_other').subscribe((translation: string) => {
                  text = translation;
                });
                this._phrutilService.showInfo(text);
                // this._phrutilService.showInfo("You can only add one Other insurance");
              }
            }
          }
    }
    else {
      if (this.insurancemodel)
        this.Update_Insurance_Info();
      else
        this.Add_insurance_info();
    }
    return true;
  }
  showconfirmationmodal() {
    if (this._addpatientinsurancemodel.insuranceId || (this.UpdateInsuranceModel.insuranceId && this.isNotOCRinsurance)) {
      $("#Insurance-Modal").modal("hide");
      $("#insuranceclosemodel").modal("show");
    }
    else {
      this.ClearInsuranceInfo();
    }
  }
  ClearInsuranceInfo() {
    $("#Insurance-Modal").modal("hide");
    this.searchinsurancemodel.insuranceName = "";
    this.insuranceNameError = false;
    this.policyNumberError = false;
    this.insurancecat = 'P';
    this.isShowSubscriberForm = false;
    this._addpatientinsurancemodel = new AddInsuranceModel();
    this.UpdateInsuranceModel = new UpdateInsuranceModel();
    this._updatesubscriberinfo = new UpdateSubscriberInfo();
    this.ResetSubscriberData();
  }

  async Update_Insurance_Info() {
    console.log("update insurance");
    if (this._addpatientinsurancemodel.relationship != "S") {

      if (!this.subcriberReq && (this._addpatientinsurancemodel.guarantoR_CODE == null || this._addpatientinsurancemodel.guarantoR_CODE == undefined || this._addpatientinsurancemodel.guarantoR_CODE.length == 0)) {
        let text = "Select Relation as 'Self' or add Subscriber";
        this.translateService.get('Alerts.insurance_select_relation_as_self').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("Select Relation as 'Self' or add Subscriber");
        return false;
      }
      else {
        await this.AddSubscriberInfo();
      }

      if ((this._guarantor == undefined || this._guarantor == null) && (this._addpatientinsurancemodel.guarantoR_CODE == null || this._addpatientinsurancemodel.guarantoR_CODE == undefined || this._addpatientinsurancemodel.guarantoR_CODE.length == 0)) {
        let text = "Select Relation as 'Self' or add Subscriber";
        this.translateService.get('Alerts.insurance_select_relation_as_self').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("Select Relation as 'Self' or add Subscriber");
        return false;
      }
      else if (this._addpatientinsurancemodel.guarantoR_CODE != null && this._addpatientinsurancemodel.guarantoR_CODE != undefined && this._addpatientinsurancemodel.guarantoR_CODE.length > 1) {
        this.UpdateInsuranceModel.subscriber = this._addpatientinsurancemodel.guarantoR_CODE;
      }
      else {
        this.UpdateInsuranceModel.subscriber = this._guarantor.guarantorCode;
      }
    }
    else {
      this.UpdateInsuranceModel.subscriber = '';
    }
    this.UpdateInsuranceModel.patientAccount = this.patientpersonalinfo.PATIENT_ACCOUNT.toString();
    this.UpdateInsuranceModel.practiceCode = this.patientpersonalinfo.PRACTICE_CODE;
    this.UpdateInsuranceModel.allowedVisit = this._addpatientinsurancemodel.allowedVisit;
    this.UpdateInsuranceModel.copay = this._addpatientinsurancemodel.copay;
    this.UpdateInsuranceModel.copayPercent = this._addpatientinsurancemodel.copayPercent;
    this.UpdateInsuranceModel.createdBy = this.patientpersonalinfo.PATIENT_ACCOUNT.toString();
    this.UpdateInsuranceModel.deductable = this._addpatientinsurancemodel.deductable;
    this.UpdateInsuranceModel.effectiveFrom = this._addpatientinsurancemodel.effectiveFrom;
    this.UpdateInsuranceModel.effectiveTo = this._addpatientinsurancemodel.effectiveTo;
    this.UpdateInsuranceModel.groupId = this._addpatientinsurancemodel.groupId;
    this.UpdateInsuranceModel.groupName = this._addpatientinsurancemodel.groupName;
    this.UpdateInsuranceModel.policyNumber = this._addpatientinsurancemodel.policyNumber;
    this.UpdateInsuranceModel.relationship = this._addpatientinsurancemodel.relationship;
    this.UpdateInsuranceModel.type = this.insurancecat;
    this._addpatientinsurancemodel.type = this.insurancecat;
    this.UpdateInsuranceModel.wcInfo = this._addpatientinsurancemodel.wcInfo;
    this.spinner.show();
    this._insuranceservice.UpdatePatientInsurance(this.UpdateInsuranceModel).subscribe((res: any) => {
      $('#Insurance-Modal').modal('hide');
      this.spinner.hide();
      this.ClearInsuranceInfo();
      if (res.statusCode == 200) {
        let text = "Insurance updated successfully";
        this.translateService.get('Alerts.insurance_updated').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showSuccess(text);
        //this._phrutilService.showSuccess("Insurance updated successfully");
        this.GetPatientInsuranceInfo(this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE, this.appointmentId);
        return true;
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        // this._phrutilService.showError("Service is not available, please try later.");
        return false;
      }
    },
      (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        // this._phrutilService.showError("Service is not available, please try later.");
      })
    return true;
  }
  insuranceType: any;
  isFrontDone: boolean = false;
  newPrimaryInsuranceAdded: any = false;
  async Add_insurance_info() {
    console.log("inside main");
    if (this.isPrimaryInsuranceInactive == true && this.insurancecat === 'P') {
      if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P')) {
        const result = this._insurances.find(res => res.prI_SEC_OTH_TYPE === 'P')
        this.DeleteInactiveInsurance(result);
      }
    }
    if (this._addpatientinsurancemodel.relationship != "S") {
      if (!this.subcriberReq) {
        let text = "Select Relation as 'Self' or add Subscriber";
        this.translateService.get('Alerts.insurance_select_relation_as_self').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("Select Relation as 'Self' or add Subscriber");
        return false;
      }
      else {
        await this.AddSubscriberInfo();
      }

      if (this._guarantor == undefined || this._guarantor == null) {
        let text = "Select Relation as 'Self' or add Subscriber";
        this.translateService.get('Alerts.insurance_select_relation_as_self').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        // this._phrutilService.showInfo("Select Relation as 'Self' or add Subscriber");
        return false;
      }
      else {
        this._addpatientinsurancemodel.subscriber = this._guarantor.guarantorCode;
      }
    }
    this._addpatientinsurancemodel.createdBy = this.patientpersonalinfo.PATIENT_ACCOUNT.toString();
    this._addpatientinsurancemodel.patientAccount = this.patientpersonalinfo.PATIENT_ACCOUNT;
    this._addpatientinsurancemodel.practiceCode = this.patientpersonalinfo.PRACTICE_CODE;
    this._addpatientinsurancemodel.type = this.insurancecat;
    const insuranceType=this._addpatientinsurancemodel.type;
    // console.log("category ", this._addpatientinsurancemodel.type);
    this.spinner.show();
    this._insuranceservice.AddPatientInsurance(this._addpatientinsurancemodel).subscribe((res: any) => {
      $('#Insurance-Modal').modal('hide');
      this.spinner.hide();
      // console.log("front & back " + this.fileObjFront, this.fileObjBack);
      if (this.fileObjFront && this.fileObjBack) {
        this.AddinsurancePhoto();
      }
      this.ClearInsuranceInfo();
      if (res.statusCode == 200) {
        console.log("category ", insuranceType);
        if (insuranceType ==='P') {
          this.isPrimaryInsuranceInactive = false;
          this.newPrimaryInsuranceAdded = true;
          localStorage.setItem("newIns", this.newPrimaryInsuranceAdded);
          this.appointmentId = '0';

        }
        this.GetPatientInsuranceInfo(this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE, this.appointmentId);
        let text = "Insurance added successfully";
        this.translateService.get('Alerts.insurance_added').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showSuccess(text);
        // this._phrutilService.showSuccess("Insurance added successfully");
        return true;
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        // this._phrutilService.showError("Service is not available, please try later.");
        return false;
      }
    },
      (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      })

    return true;
  }

  checkIsAlreadyPhotoUpload() {
    let isAlreadyPhotoUpload = localStorage.getItem('alreadyUpload');
    if (isAlreadyPhotoUpload != 'true') {
      this.AddinsurancePhoto();
    } else {
      this.Next();
    }
  }

  AddinsurancePhoto() {
    let isAlreadyPhotoUpload = localStorage.getItem('alreadyUpload');
    //this.callOCRinsuranceService();
    if (this.fileObjFront) {
      this.isRequireFrontCard = false;
      // this.fileArray.push(this.fileObjFront);
    }
    else {
      if (isAlreadyPhotoUpload !='true') {
        console.log("front photo required");
        this.isRequireFrontCard = true;
        this.scrollTobuttomandTop(true);
      }
      return;
    }
    if (this.fileObjBack) {
      this.isRequireBackCard = false;
      //this.fileArray.push(this.fileObjBack);
    }
    else {
      if (isAlreadyPhotoUpload != 'true') {
        this.scrollTobuttomandTop(false);
        this.isRequireBackCard = true;
        this.scrollToBackInput();
        //show alert
        //$('#backPhotoRequiredModal').modal('show');
      }

      return;
    }

    //check if primary insurance is already exist and inactive then delete it
    if (this.isPrimaryInsuranceInactive == true && this.insurancecat === 'P') {
      if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P')) {
        const result = this._insurances.find(res => res.prI_SEC_OTH_TYPE === 'P')
        this.DeleteInactiveInsurance(result);
      }
    }


    //  Primary_front
    if (this.insurancecat === 'P') {
      this.insuranceType = 'Primary'
    } else if (this.insurancecat === 'S') {
      this.insuranceType = 'Secondary'
    } else {
      this.insuranceType = 'Other'
    }

    this.spinner.show();
    if (this.fileObjFront) {
      const subtype = this.insuranceType + " Insurance – Front";
      //this._intakeMedicationService.uploadAtFolder(this.fileObjFront, "api/TalkCheckin/SaveMedicine_Photo", this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE).subscribe((res: any) => {
      this._insuranceservice.uploadAtFolder(this.fileObjFront, "api/TalkCheckin/SaveInsurances_Photo_EHR", this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE, subtype).subscribe((res: any) => {
        // this.spinner.hide();
        //$("#Medical-History-Modal").modal("hide");
        if (res.statusCode == 200) {
          //console.log("back" + this.fileObjBack)
          this.addBackPhoto();
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);

          //this._phrutilService.showError("Service is not available, please try later.");
        }
      },
        (error: any) => {
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
        }
      );
    }
  }
  isphotoupload: any=false;
  addBackPhoto() {
    console.log("back photo upload")
    // console.log("back" + this.fileObjBack)
    if (this.fileObjBack) {
      //   console.log("back" + this.fileObjBack)
      const subtype = this.insuranceType + " Insurance – Back";

      //this._insuranceservice.uploadAtFolder(this.fileObjBack, "api/TalkCheckin/SaveInsurances_Photo", this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE, subtype).subscribe((res: any) => {
      this._insuranceservice.uploadAtFolder(this.fileObjBack, "api/TalkCheckin/SaveInsurances_Photo_EHR", this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE, subtype).subscribe((res: any) => {
        this.spinner.hide();
        console.log("back uploaded")
        if (res.statusCode == 200) {
          let text = "Thank you for providing your insurance details. Your doctor will update your file accordingly.";
          this.translateService.get('insurances.thank_you').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showSuccess(text);
          this.isphotoupload = true;
          if (this.insuranceType === 'Primary') {
            this.isPrimaryInsuranceInactive = false;
            this.newPrimaryInsuranceAdded = true;
            localStorage.setItem("newIns", this.newPrimaryInsuranceAdded)
            this.appointmentId = '0';
          }

          localStorage.setItem('alreadyUpload', 'true');
          // this._phrutilService.showSuccess('Thank you for providing your insurance details. Your doctor will update your file accordingly.');
          this.GetPatientInsuranceInfo(this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE, this.appointmentId);
          //localStorage.setItem("itype", this.insuranceType);
          //const insurancetype = localStorage.getItem("itype")
          //console.log("istype " + insurancetype);
          //if (insurancetype === 'Secondary') {
          //  this.insurancecat = 'O';
          //} else if (insurancetype === 'Primary') {
          //  this.insurancecat = 'S';
          //} else {
          //  this.insurancecat = 'P';
          //}

          this.fileObjFront = '';
          this.fileObjBack = '';
          this.fileArray = Array();
          this.isFrontPhotoUpload = false;
          this.isbackPhotoUpload = false;
          // this.ClearInsuranceInfo();
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
      },
        (error: any) => {
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
        }
      );
    }
  }
  async AddSubscriberInfo() {

    this._updatesubscriberinfo.modified_By = this.patientpersonalinfo.PATIENT_ACCOUNT.toString();
    this._updatesubscriberinfo.patientAccount = this.patientpersonalinfo.PATIENT_ACCOUNT;
    this._updatesubscriberinfo.practiceCode = this.patientpersonalinfo.PRACTICE_CODE;
    this._updatesubscriberinfo.GUARANT_PRACTICE_CODE = this.patientpersonalinfo.PRACTICE_CODE;
    this._updatesubscriberinfo.GUARANT_TYPE = "S";
    this.spinner.show();
    await this._insuranceservice.AddSubscriber(this._updatesubscriberinfo).then((res: any) => {
      this.spinner.hide();
      if (res.statusCode == 200) {
        this._guarantor = res.data as AddSubscriberResponse;
        return true;
      }
      else {
        this.spinner.hide();
        return false;
      }
    },
      (error: any) => {
        this.spinner.hide();
      })

  }
  /*selectInsurance(event: any) {
    const option = event;
    //console.log(option +" outside");
    if (option) {
    //  this.insurancecat = option;
      if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === option)) {
       // console.log(option +" inside");
        if (option === 'P') {
          let text = "You can only add one primary insurance";
          this.translateService.get('Alerts.insurance_only_add_one_primary').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showInfo(text);
        } else if (option === 'S') {
          let text = "You can only add one secondary insurance";
          this.translateService.get('Alerts.insurance_only_add_one_secondary').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showInfo(text);
        } else if (option === 'O') {
          let text = "You Can Only Add One Other Insurance";
          this.translateService.get('Alerts.insurance_only_add_one_other').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showInfo(text);
        }
      }
    }
  }*/

  selectInsurance(event: any) {

    const option = (event.target as HTMLSelectElement)?.value;
    if (option) {
      this.insurancecat = option;
      if (!this.insurancemodel) {
        this.ClickInsuranceInfo(option, true);
      }
      if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === option)) {
        if (option === 'P' && this.isPrimaryInsuranceInactive == false) {
          let text = "You can only add one primary insurance";
          this.translateService.get('Alerts.insurance_only_add_one_primary').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showInfo(text);

        } else if (option === 'S') {
          let text = "You can only add one secondary insurance";
          this.translateService.get('Alerts.insurance_only_add_one_secondary').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showInfo(text);;
        } else if (option === 'O') {
          let text = "You Can Only Add One Other Insurance";
          this.translateService.get('Alerts.insurance_only_add_one_other').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showInfo(text);
        }
        return true;
      }
    }
    return true;
  }

  isNotOCRinsurance: any = false;

  addInsurancemodle(patientinsuranceinfo: any, checkinsurance: boolean, isManual = false) {

    this.ClearInsuranceInfo();
    this.insurancemodel = checkinsurance;

    if (patientinsuranceinfo != undefined && this.insurancemodel == true) {
      this.translateService.get('button.update').subscribe((translation: string) => {
        this.insurancetype = translation;
      });
      //this.insurancetype = "Update"
      this.spinner.show();
      this.UpdateInsuranceModel.patientInsuranceId = patientinsuranceinfo.patienT_INSURANCE_ID;
      this.UpdateInsuranceModel.insuranceId = patientinsuranceinfo.insurancE_ID;

      this.displayInsuranceName = patientinsuranceinfo.inspayeR_DESCRIPTION;
      this.searchinsurancemodel.insuranceName = patientinsuranceinfo.inspayeR_DESCRIPTION;
      this.insuranceNamePopup = patientinsuranceinfo.inspayeR_DESCRIPTION;
      this._addpatientinsurancemodel.groupName = patientinsuranceinfo.group_Name;
      this._addpatientinsurancemodel.groupId = patientinsuranceinfo.group_Number;
      this._addpatientinsurancemodel.subscriber = (patientinsuranceinfo.subscriber.length >= 3) ? patientinsuranceinfo.subscriber : null;
      this._addpatientinsurancemodel.guarantoR_CODE = patientinsuranceinfo.guarantoR_CODE;
      this._addpatientinsurancemodel.policyNumber = patientinsuranceinfo.policY_NUMBER;
      let dob = patientinsuranceinfo.effective_Date;
      if (dob) {
        this._addpatientinsurancemodel.effectiveFrom = this.datepipe.transform(dob, 'yyyy-MM-dd');
      } else {
        this._addpatientinsurancemodel.effectiveFrom = "";
      }
      let dob1 = patientinsuranceinfo.termination_Date;  //.substr(0, 10);
      if (dob1) {
        this._addpatientinsurancemodel.effectiveTo = this.datepipe.transform(dob1, 'yyyy-MM-dd');
      } else {
        this._addpatientinsurancemodel.effectiveTo = "";
      }

      this._addpatientinsurancemodel.relationship = patientinsuranceinfo.relationship;
      this._addpatientinsurancemodel.allowedVisit = patientinsuranceinfo.allowed_Visits;
      this._addpatientinsurancemodel.copayPercent = patientinsuranceinfo.cO_PAYMENT_PER;
      this._addpatientinsurancemodel.copay = patientinsuranceinfo.co_Payment;
      this._addpatientinsurancemodel.deductable = patientinsuranceinfo.deductions;
      this._addpatientinsurancemodel.wcInfo = patientinsuranceinfo.filing_indicator;
      this.insurance_type = patientinsuranceinfo.prI_SEC_OTH_TYPE;
      this.ClickInsuranceInfo(patientinsuranceinfo.prI_SEC_OTH_TYPE, false);
      this.GetSubscriberDetails(this._addpatientinsurancemodel.guarantoR_CODE);
      if (isManual) {
        this.isNotOCRinsurance = true;
        this.addInsurance = true;
        this.addInsuranceManuallyNew();
        this.InsuranceDetails = false;
        // $('#Insurance-Modal').modal('show');
      }
      else {
        this.isNotOCRinsurance = true;
        $('#Captured-Modal').modal('show');
      }
    }
    else {
      this.isNotOCRinsurance = false;
      this.translateService.get('button.add').subscribe((translation: string) => {
        this.insurancetype = translation;
      });
      //this.insurancetype = "Add";
      this._addpatientinsurancemodel.relationship = 'S';
      $('#Insurance-Modal').modal('show');
    }
    return true;
  }
  GetSubscriberDetails(guarantoR_CODE: any) {
    if (guarantoR_CODE && guarantoR_CODE.length > 1) {
      this._insuranceservice.GetSubscriberDetails(this.patientpersonalinfo.PRACTICE_CODE, this.patientpersonalinfo.PATIENT_ACCOUNT, guarantoR_CODE).subscribe((res: any) => {
        this.spinner.hide();
        if (res.statusCode == 200) {
          this.getSubscriberDetails = res.data;
          this.subcriberReq = true;
          this._updatesubscriberinfo.guaranT_CITY = this.getSubscriberDetails.guaranT_CITY;
          this._updatesubscriberinfo.guaranT_LNAME = this.getSubscriberDetails.guaranT_LNAME;
          this._updatesubscriberinfo.guaranT_FNAME = this.getSubscriberDetails.guaranT_FNAME;
          this._updatesubscriberinfo.guaranT_MI = this.getSubscriberDetails.guaranT_MI;
          this._updatesubscriberinfo.guaranT_ADDRESS = this.getSubscriberDetails.guaranT_ADDRESS;
          this._updatesubscriberinfo.guaranT_STATE = this.getSubscriberDetails.guaranT_STATE;
          this._updatesubscriberinfo.guarant_zip = this.getSubscriberDetails.guaranT_ZIP;
          this._updatesubscriberinfo.guarant_dob = this.datepipe.transform(this.getSubscriberDetails.guaranT_DOB, 'MM/dd/yyyy');
          this._updatesubscriberinfo.guaranT_SSN = this.getSubscriberDetails.guaranT_SSN;
          this._updatesubscriberinfo.guaranT_GENDER = this.getSubscriberDetails.guaranT_GENDER;
          this._updatesubscriberinfo.guaranT_HOME_PHONE = this.getSubscriberDetails.guaranT_HOME_PHONE;
          this._updatesubscriberinfo.guaranT_WORK_PHONE = this.getSubscriberDetails.guaranT_WORK_PHONE;
          this._updatesubscriberinfo.guaranT_WORK_PHONE_EXT = this.getSubscriberDetails.guaranT_WORK_PHONE_EXT;
          this._updatesubscriberinfo.guarantoR_CODE = this.getSubscriberDetails.guarantoR_CODE;
          this._updatesubscriberinfo.GUARANT_PRACTICE_CODE = this.getSubscriberDetails.guarant_practice_code;
          this._updatesubscriberinfo.GUARANT_TYPE = this.getSubscriberDetails.guarant_Type;
        }
      }, (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      });
    }
    else {
      this.spinner.hide();
    }
  }
  editSubscriber() {
    $('#Insurance-Modal').modal('hide');
    $('#Subscriber-Modal').modal('show');
    this.translateService.get('button.update').subscribe((translation: string) => {
      this.subSAction = translation;
    });
    //this.subSAction ="Update";
    this.onFocusOutZIPSubsciber(this._updatesubscriberinfo.guarant_zip, 1);
    this._updatesubscriberinfo.guarant_dob = this.datepipe.transform(this._updatesubscriberinfo.guarant_dob, 'MM/dd/yyyy');
  }
  deleteSubscriber() {
    this._updatesubscriberinfo = new UpdateSubscriberInfo();
    this.isShowSubscriberForm = true;
    this.ResetSubscriberData();
    this._addpatientinsurancemodel.subscriber = '';
    let text = "Subscriber deleted successfully";
    this.translateService.get('Alerts.subscriber_deleted').subscribe((translation: string) => {
      text = translation;
    });
    this._phrutilService.showSuccess(text);
    //this._phrutilService.showSuccess("Subscriber deleted successfully");
  }
  backClick() {
    // this.router.navigateByUrl('patient/careteam')
    this.router.navigateByUrl('patient/updateinfo');
  }
  Next() {
    console.log("front and back");
    // console.log(this.fileObjFront, this.fileObjBack)
    //if (this.fileObjFront || this.fileObjBack) {
    //  this.AddinsurancePhoto();
    //  //this.nextClick();
    //} else if (this._addpatientinsurancemodel.insuranceId) {
    //  this.Add_Insurance_Info_confirmation_model();
    //} 
    if (this._addpatientinsurancemodel.insuranceId) {
      this.Add_Insurance_Info_confirmation_model();
    } else if (this.fileObjFront || this.fileObjBack) {
      this.AddinsurancePhoto();
    } else if (this.noInsuranceScreen) {
      this.noInsuranceScreen = false,
        this.addInsurance = true
      this.addInsuranceBycard()
    }
    //else if (this.isPrimaryInsuranceInactive == true && this.isPrimaryInsurancealredyExist==true) {
    //  console.log("inactive true ",this.isPrimaryInsuranceInactive);
    //  return;
    //}
    else {
      this.nextClick();
    }

    //const insurancetype = localStorage.getItem("itype")
    //console.log(insurancetype);
    //if (this.addInsurancemanually) {
    //  this.Add_Insurance_Info_confirmation_model();
    //} else if (this.InsuranceDetails || insurancetype === 'Primary' || insurancetype === 'Secondary') {
    //  if (this.fileObjFront && this.fileObjBack) {
    //    this.AddinsurancePhoto();
    //  } else { this.nextClick(); }

    //} else if (this.AddinsuranceBycard) {
    //  this.AddinsurancePhoto();
    //}



  }
  nextClick() {
    localStorage.setItem("backFromCovid","false");
    this.router.navigateByUrl('patient/intake');
    /*
    const storedIsWithin24Hours = localStorage.getItem('isWithin24Hours');
    const practiceCode = localStorage.getItem('pcode');
    const reason = localStorage.getItem('reason');
    console.log('24 hour check ' + storedIsWithin24Hours);
    if (practiceCode == '1011163') {
      localStorage.setItem('backfromintake', 'false');
      this.router.navigateByUrl('patient/symptomsquestion');
    } else {
      if (practiceCode == '100' && reason == 'Initial Visit') {
        if (storedIsWithin24Hours == 'true') {
          console.log("with in 24 hours with initial visit");
          localStorage.setItem('backfromintake', 'false');
          this.router.navigateByUrl('patient/visit-reason');
        } else {
          console.log("not in 24 hours with initial visit");
          localStorage.setItem("backFromCovid", "false");
          this.router.navigateByUrl('patient/intake');
        }
      } else {
        console.log("no initial visit");
        localStorage.setItem('backfromintake', 'false');
        this.router.navigateByUrl('patient/visit-reason');
      }
    }
    */

  }



  onChangeFileFront(event: any) {

    this.fileObjFront = event.target.files[0];
    if (!this.fileObjFront) return;

    const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
   // console.log("fileObjFront type", this.fileObjFront.type)
    if (!validTypes.includes(this.fileObjFront.type)) {
      let text = "Invalid file type! Please upload PNG, JPG or JPEG only.";
      this.translateService.get('Alerts.invalid_image').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
     // console.log('Invalid file type! Please upload PNG, JPG or JPEG only.');
      event.target.value = ''; // reset file input
      this.fileObjFront = '';
      this.defaultImagefront = '';
      this.isFrontPhotoUpload = false;
      return;
    }
    //this.fileObjFront = event.target.files[0];
    if (this.fileObjFront) {
      // localStorage.setItem("photoback", '');
      if (this.fileObjBack == '')
        this.isbackPhotoUpload = false;
      this.showPreview(event, 'front');
      this.isRequireFrontCard = false;
      event.target.value = '';
      this.scrollToBackInput();
      localStorage.setItem('alreadyUpload', 'false');
      if (this.patientpersonalinfo.PRACTICE_CODE != 2410007)
      this.OCRinsuranceServiceNew();

    }
    else {
      this.isRequireFrontCard = true;
      return;
    }
  }
  onChangeFileBack(event: any) {
    this.fileObjBack = event.target.files[0];
    if (!this.fileObjBack) return;

    const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
    console.log("fileObjFront type", this.fileObjBack.type)
    if (!validTypes.includes(this.fileObjBack.type)) {
      let text = "Invalid file type! Please upload PNG, JPG or JPEG only.";
      this.translateService.get('Alerts.invalid_image').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
      console.log('Invalid file type! Please upload PNG, JPG or JPEG only.');
      event.target.value = ''; // reset file input
      this.fileObjBack = '';
      this.defaultImageback = '';
      this.isbackPhotoUpload = false;
      return;
    }

    if (this.fileObjBack) {
      if (this.fileObjFront == '')
        this.isFrontPhotoUpload = false;
      //localStorage.setItem("photofront", '');
      this.showPreview(event, 'back');
      this.isRequireBackCard = false;
      event.target.value = '';
      localStorage.setItem('alreadyUpload', 'false');
      if (this.patientpersonalinfo.PRACTICE_CODE != 2410007)
      this.OCRinsuranceServiceNew();
    }
    else {
      this.isRequireBackCard = true;
      return;
    }
  }
  isRequireFrontCard: any = false;
  isRequireBackCard: any = false;
  callOCRinsuranceService() {

    if (this.fileObjFront) {
      this.isRequireFrontCard = false;
      this.fileArray.push(this.fileObjFront);
    }
    else {
      this.isRequireFrontCard = true;
      this.scrollTobuttomandTop(true);
      return;
    }
    if (this.fileObjBack) {
      this.isRequireBackCard = false;
      this.fileArray.push(this.fileObjBack);
    }
    else {
      this.scrollTobuttomandTop(false);
      this.isRequireBackCard = true;
      return;
    }
    //console.log(this.isRequireFrontCard);
    this.spinner.show();
    this._insuranceservice.OcrInsurance(this.fileArray).subscribe((res: any) => {
      this.spinner.hide();
      $("#Captured-Modal").modal("hide");
      if (res && res["Insurance Name"] && res["Insurance Name"].length > 0 && (this.insuranceDescriptionOCR.toLowerCase().includes(res["Insurance Name"].toLowerCase()) || this.searchinsurancemodel.insuranceName.toLowerCase().includes(res["Insurance Name"].toLowerCase()))) {
        this.OcrResponce = res;
        this._addpatientinsurancemodel.policyNumber = this.OcrResponce['Insurance ID'];
        this._addpatientinsurancemodel.groupId = this.OcrResponce['Group Number'].length > 0 ? this.OcrResponce['Group Number'] : this._addpatientinsurancemodel.groupId;
        this.isNotOCRinsurance = true;
        //$("#Insurance-Modal").modal("show");
      }
      else {
        // $("#incorrectinfoocr-model").modal("show");
      }
      this.fileArray = Array();
      this.defaultImagefront = 'assets/images/card-front.png';
      this.defaultImageback = 'assets/images/card-back.png';

    }, (error: any) => {

      this.spinner.hide();
      this.fileArray = Array();
      this.defaultImagefront = 'assets/images/card-front.png';
      this.defaultImageback = 'assets/images/card-back.png';
      this.fileObjFront = "";
      this.fileObjBack = "";
      $("#Captured-Modal").modal("hide");
      //$("#incorrectinfoocr-model").modal("show");
    })

  }

  OCRinsuranceServiceNew() {
    if (this.fileObjFront) {
      this.isRequireFrontCard = false;
    }
    else {
      this.isRequireFrontCard = true;
      this.scrollTobuttomandTop(true);
      return;
    }
    if (this.fileObjBack) {
      this.isRequireBackCard = false;
    }
    else {
      this.scrollTobuttomandTop(false);
      this.isRequireBackCard = true;
      return;
    }

    this.spinner.show();
    this._insuranceservice.OcrInsuranceNew(this.fileObjFront, this.fileObjBack,"true").subscribe((res: any) => {
      this.spinner.hide();
      if (res.encrypted == true && res.iv) {
        res.Data.Insurance_Id = res.Data.Insurance_Id ? this._phrutilService.decryptforInsuranceCard(res.Data.Insurance_Id, res.iv) : res.Data.Insurance_Id;
        res.Data.InsPayer_Description = res.Data.InsPayer_Description ? this._phrutilService.decryptforInsuranceCard(res.Data.InsPayer_Description, res.iv) : res.Data.InsPayer_Description;
        res.Data.InsName_Id = res.Data.InsName_Id ? this._phrutilService.decryptforInsuranceCard(res.Data.InsName_Id, res.iv) : res.Data.InsName_Id;
        res.Data.InsGroup_Id = res.Data.InsGroup_Id ? this._phrutilService.decryptforInsuranceCard(res.Data.InsGroup_Id, res.iv) : res.Data.InsGroup_Id;
        res.Data.InsGroup_Name = res.Data.InsGroup_Name ? this._phrutilService.decryptforInsuranceCard(res.Data.InsGroup_Name, res.iv) : res.Data.InsGroup_Name;
        res.Data.policyNumber = res.Data.policyNumber ? this._phrutilService.decryptforInsuranceCard(res.Data.policyNumber, res.iv) : res.Data.policyNumber;
        res.Data.Confidence_Score = res.Data.Confidence_Score ? this._phrutilService.decryptforInsuranceCard(res.Data.Confidence_Score, res.iv) : res.Data.Confidence_Score;
        //console.log("res",res.Data)
        if (res.Data && res.Data.Insurance_Id && res.Data.policyNumber) {
          console.log("inside ocr encrypted");
          //console.log("addpatientinsurancemodel", this._addpatientinsurancemodel)
          this.insuranceNamePopup = res.Data.InsPayer_Description;
          this._addpatientinsurancemodel.policyNumber = res.Data.policyNumber;
          this._addpatientinsurancemodel.groupName = res.Data.InsGroup_Name;
          this._addpatientinsurancemodel.relationship = 'S';
          this._addpatientinsurancemodel.addedFrom = "OCR";
          this._addpatientinsurancemodel.groupId = (res.Data.InsGroup_Id && res.Data.InsGroup_Id.length > 0)
            ? this.parseIntValue(res.Data.InsGroup_Id).toString() : '';
          this._addpatientinsurancemodel.insuranceId = this.parseIntValue(res.Data.Insurance_Id).toString();
          this.insName_Id = this.parseIntValue(res.Data.InsName_Id).toString();
          this.isNotOCRinsurance = true;
          // console.log("addpatientinsurancemodel", this._addpatientinsurancemodel)
          this.addInsuranceManuallyBycard();
        }
        else {
          console.log("no record found");
        }
      } else {
        console.log("res",res)
        if (res && res.Insurance_Id && res.policyNumber) {
          console.log("inside ocr normal");
          this.insuranceNamePopup = res.InsPayer_Description;
          this._addpatientinsurancemodel.policyNumber = res.policyNumber;
          this._addpatientinsurancemodel.groupId = res.InsGroup_Id.toString().length > 0 ? res.InsGroup_Id.toString() : '';
          this._addpatientinsurancemodel.insuranceId = res.Insurance_Id.toString();
          this._addpatientinsurancemodel.groupName = res.InsGroup_Name;
          this._addpatientinsurancemodel.relationship = 'S';
          this._addpatientinsurancemodel.addedFrom = "OCR";
          this.insName_Id = res.InsName_Id.toString();
          this.isNotOCRinsurance = true;
          //  console.log("add insurance modal ", this._addpatientinsurancemodel);
          this.addInsuranceManuallyBycard();
          //$("#Insurance-Modal").modal("show");
        }
        else {
          console.log("no record found");
          // $("#incorrectinfoocr-model").modal("show");
        }
      }
    }, (error: any) => {

      this.spinner.hide();
      // this.fileArray = Array();
      // this.defaultImagefront = 'assets/images/card-front.png';
      // this.defaultImageback = 'assets/images/card-back.png';
      // this.fileObjFront = "";
      // this.fileObjBack = "";
      //  $("#Captured-Modal").modal("hide");
      //$("#incorrectinfoocr-model").modal("show");
    })

  }

  parseIntValue(value: any): number | null {
    if (typeof value === 'string' && value.startsWith('INT:')) {
      return parseInt(value.replace('INT:', ''), 10);
    } else if (typeof value === 'number') {
      return value;
    }
    return null;
  }


  add_insurance_manual() {

    if (!this._addpatientinsurancemodel.insuranceId && !this.UpdateInsuranceModel.insuranceId) {
      this.insuranceNameError = true;
      return false;
    }
    else {
      this.insuranceNameError = false;
    }
    if (this.insuranceDescriptionOCR.toLowerCase().includes("medicare") || this.searchinsurancemodel.insuranceName.toLowerCase().includes('medicare') ||
      this.insuranceDescriptionOCR.toLowerCase().includes("cigna") || this.searchinsurancemodel.insuranceName.toLowerCase().includes('cigna') ||
      this.insuranceDescriptionOCR.toLowerCase().includes("aetna medicare") || this.searchinsurancemodel.insuranceName.toLowerCase().includes('aetna medicare') ||
      this.insuranceDescriptionOCR.toLowerCase().includes("railroad") || this.searchinsurancemodel.insuranceName.toLowerCase().includes('railroad')) {
      if (this.insuranceNamePopup.length > 2) {
        // $("#Captured-Modal").modal("show");
        $("#Insurance-Modal").modal("hide");
      }
      else {
        // $("#Captured-Modal").modal("show");
      }
    }
    else {
      $('#dd-rel').val('').trigger("change");
      //show insurance card when the OCR is not exit for this insurance
      this.isNotOCRinsurance = true;
      this.translateService.get('button.add').subscribe((translation: string) => {
        this.insurancetype = translation;
      });
      //this.insurancetype = "Add";
      // this._addpatientinsurancemodel.relationship = 'S';
      // $('#Insurance-Modal').modal('show');
      const insurancetype = localStorage.getItem("itype")
      // console.log("istype " + insurancetype);
      // console.log("istypecat " + this.insurancecat);
      //if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'O') || insurancetype === 'Other') {

      //  this.insurancecat = 'P';

      //}else if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'S')|| insurancetype === 'Secondary') {

      //  this.insurancecat = 'O';

      //} else if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P') || insurancetype === 'Primary') {

      //  this.insurancecat = 'S';

      //} else {

      //  this.insurancecat = 'P';

      //}
      console.log("istypecat " + this.insurancecat);
    }
    if (this._insurances.length == 3) {
      let text = "You cannot add more then 3 insurance";
      this.translateService.get('Alerts.insurance_moreThan_3').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showInfo(text);
      $('#Insurance-Modal').modal('hide');
      $("#Captured-Modal").modal("hide");
      return false;
    }
    return true;
  }
  scanCard() {
    $("#Captured-Modal").modal("show");
  }

  addInsuranceManullay() {
    $("#Captured-Modal").modal("hide");
    //$("#Insurance-Modal").modal("show");
    this.addInsurance = true;
    //this.addInsuranceManuallyNew();
    this.InsuranceDetails = false;

    if (this.insName_Id == '5001996') {
      $('#dd-rel').val('S').trigger("change");
      this._addpatientinsurancemodel.relationship = 'S';
    }
    else {
      $('#dd-rel').val('').trigger("change");
    }
    const insurancetype = localStorage.getItem("itype")
    console.log("istype " + insurancetype);
    this.isNotOCRinsurance = true;
    //if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'O') || insurancetype === 'Other') {

    //  this.insurancecat = 'P';

    //} else if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'S') || insurancetype === 'Secondary') {

    //  this.insurancecat = 'O';

    //} else if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P') || insurancetype === 'Primary') {

    //  this.insurancecat = 'S';

    //} else {

    //  this.insurancecat = 'P';

    //}
  }
  showCaptureModel() {
    // $("#Captured-Modal").modal("show");
  }
  closeCaptureCard(type: any) {
    if (type == 'close')
      //$("#Insurance-Modal").modal("show");
      this.fileArray = Array();
    this.fileObjFront = "";
    this.fileObjBack = "";
    this.isRequireFrontCard = false;
    this.isRequireBackCard = false;
  }

  showPop(element: any) {
    this.isPopup = !this.isPopup;
    $('#pop' + element).toggleClass('d-none');

  }
  selfpay: boolean = false;
  selfPay() {
    if ($('#selfPayCheckbox').prop("checked")) {
      this.selfpay = true;
    }
    else {
      this.selfpay = false;
    }

  }
  deleteInsurance: any;
  _deletepatientinsurance: DeleteInsuranceModel = new DeleteInsuranceModel();
  OpendeleteModel(insurance: any) {

    if (insurance.insurancE_ID != "" && insurance.insurancE_ID != undefined) {

      this._deletepatientinsurance.modifiedBy = this.patientpersonalinfo.PATIENT_ACCOUNT;
      this._deletepatientinsurance.insuranceId = insurance.insurancE_ID;
      this._deletepatientinsurance.patientAccount = this.patientpersonalinfo.PATIENT_ACCOUNT;
      this._deletepatientinsurance.practiceCode = this.patientpersonalinfo.PRACTICE_CODE;
      // console.log(insurance);
      this.deleteInsurance = insurance.prI_SEC_OTH_TYPE;
      //  console.log(this.deleteInsurance);
      $('#insurancedeletemodel').modal('show');
    }
    else {
      let text = "Please select record first";
      this.translateService.get('Alerts.insurance_select_record_first').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showWarning(text);
      //this._phrutilService.showWarning("Please select record first");
    }
  }
  DeleteInactiveInsurance(insurance: any) {
    // console.log("delete Insurance ",insurance);
    this._deletepatientinsurance.modifiedBy = this.patientpersonalinfo.PATIENT_ACCOUNT;
    this._deletepatientinsurance.insuranceId = insurance.insurancE_ID;
    this._deletepatientinsurance.patientAccount = this.patientpersonalinfo.PATIENT_ACCOUNT;
    this._deletepatientinsurance.practiceCode = this.patientpersonalinfo.PRACTICE_CODE;

    // return;
    this._insuranceservice.DeletePatientInsurance(this._deletepatientinsurance).subscribe((res: any) => {

      if (res.statusCode == 200) {
        console.log("Inactive insurance has been deleted successfully!!");
        this.isPrimaryInsuranceInactive = false;
        localStorage.setItem("insStatus", '');
      }
      else {
        console.log("Something went wrong");
      }

    },
      (error: any) => {
        console.log("Errors");
      })
  }

  DeleteInsurance() {
    this.spinner.show();
    this._insuranceservice.DeletePatientInsurance(this._deletepatientinsurance).subscribe((res: any) => {
      $('#insurancedeletemodel').modal('hide');
      this.spinner.hide();
      if (res.statusCode == 200) {
        this.isphotoupload = false;
        if (this.deleteInsurance == 'P') {
          this.isPrimaryInsuranceInactive = false;
          localStorage.setItem("insStatus", '');
        }
        //if (this.deleteInsurance == 'P') {
        //  localStorage.setItem("itype", '')
        //}else if (this.deleteInsurance == 'O') {
        //  localStorage.setItem("itype", 'Other')
        //} else if (this.deleteInsurance == 'S') {
        //  localStorage.setItem("itype", 'Primary')
        //} else {
        //  localStorage.setItem("itype", '')
        //}
        this.GetPatientInsuranceInfo(this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE, this.appointmentId);
        let text = "Insurance deleted successfully";
        this.translateService.get('Alerts.insurance_deleted').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showSuccess(text);
        //this._phrutilService.showSuccess("Insurance deleted successfully");
      }
      else
        if (res.stateCode == 400) {
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
    },
      (error: any) => {
        $('#insurancedeletemodel').modal('hide');
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      })
  }
  scrollTobuttomandTop(isScrollTop: any): void {
    try {
      if (isScrollTop) {
        this.myScrollContainer.nativeElement.scrollTop = '0';
      }
      else if (!isScrollTop) {
        this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight
      }
    } catch (err) { }
  }

  //show local image
  showPreview(event: Event, type: any) {
    let selectedFile = (event.target as HTMLInputElement).files?.item(0)
    if (selectedFile) {
      if (["image/jpeg", "image/png", "image/svg+xml", "image/gif"].includes(selectedFile.type)) {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(selectedFile);

        fileReader.addEventListener('load', (event) => {
          if (type == 'front') {
            console.log("front");
            this.isFrontPhotoUpload = true;
            this.defaultImagefront = event.target?.result;
            localStorage.setItem("photofront", event.target?.result as string);
          }

          else if (type == 'back') {
            console.log("back");
            this.isbackPhotoUpload = true;
            this.defaultImageback = event.target?.result;
            localStorage.setItem("photoback", event.target?.result as string);
          }
        })
      }
    }
  }
  checkValidDate(selecteddata: any) {
    this._updatesubscriberinfo.guarant_dob = this._phrutilService.CheckValidDateAndSetDefaultDateGlobal(selecteddata.target.value);
  }
  isDateError: boolean = false;
  onChangeDate(selecteddata: any) {
    this.isDateError = this._phrutilService.CheckDateLessThenCurretDateGlobal(selecteddata.target.value);
  }
}
